const {queue} = require('../queue');
const notificationFactory = require('./notification.factory');
const Status = require('./status');
const trackingUtils = require('od-modules/utils/tracking.utils');

const getBookingId = ({bookingId} = {}) => bookingId;
const isMobile = () => Odigeo.SessionScope.flow === 'mobile';
const notificationType = 'modification';
const tracking = {
    ACTION: 'incidents_manager',
    ONLOAD_LABEL_PREFIX: 'onload',
    ONLOAD_PARAMS: ['booking', 'PNR', 'id', 'pag'],
    CLICK_CTA_PREFIX: 'click-cta',
    CLICK_CTA_PARAMS: ['booking', 'status', 'id', 'pag'],
    VOLUNTARY_CHANGES_PREFIX: 'voluntary-change-step',
};

class Manager {
    load({data = {}, keys = {}, callback = () => {}} = {}) {
        this.data = data;
        this.keys = keys;
        this.modifications = new Status({
            bookingId: getBookingId(data),
            keys: this.keys,
        });
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.loadModificationStatus();
        this.promise.then((hasNotification) => callback(notificationType, hasNotification));
    }

    loadModificationStatus() {
        return this.modifications.then(() => {
            if (this.modifications.isValid()) {
                this.processModificationStatus(this.modifications.info);
            } else {
                this.resolve( false);
            }
        });
    }

    processModificationStatus(status = {}) {
        this.resolve( true);
        const ctaHandler = isMobile() ? () => this.getCta(status) : () => this.getCta();
        queue.addNotification(notificationFactory.create({
            keys: this.keys,
            status,
            ctaHandler,
            id: `cancelRequest-Voluntary-${this.data.bookingId}`,
        }));
        const label = trackingUtils.composeLabel(tracking.ONLOAD_LABEL_PREFIX, tracking.ONLOAD_PARAMS, this.getTrackingInfo());
        trackingUtils.trackEvent(tracking.ACTION, label);
        Odigeo.trigger('my_trips:processRefundStatus');
    }

    getCta() {
        return this.toggleDownloadAppNotification();
    }

    toggleDownloadAppNotification() {
        this.trackClick();
        Odigeo.trigger('trip_details:toggleDownloadAppNotification');
    }

    getTrackingInfo() {
        const altered = this.data.myTripStatus !== 'ALTERED' ? 'Ok' : '';
        const steps = `${this.modifications.info.currentStep}/${this.modifications.info.totalSteps}`;

        return {
            booking: `${this.data.numOfFlights}-${this.data.totalPnrsInBooking}`,
            status: `${tracking.VOLUNTARY_CHANGES_PREFIX}-${steps}`,
            PNR: `${tracking.VOLUNTARY_CHANGES_PREFIX}-${steps}:${altered}`,
            id: this.data.bookingId,
            pag: this.data.accommodationBooking === null ? 'myardp' : 'myarfl',
        };
    }

    trackClick() {
        const label = trackingUtils.composeLabel(tracking.CLICK_CTA_PREFIX, tracking.CLICK_CTA_PARAMS, this.getTrackingInfo());
        trackingUtils.trackEvent(tracking.ACTION, label);
    }
}

module.exports = new Manager();
